// extracted by mini-css-extract-plugin
module.exports = {"departments":"tf","departmentHeading":"uf","departmentSection":"vf","departmentName":"wf","departmentLink":"xf","expandIcon":"yf"};